module.exports = __webpack_public_path__ + "img/Camera3.1e1ae994.png";